import React from 'react';
import { Link } from '../../atoms/link/Link';
import styles from './FooterInfo.module.scss';

interface IconMedia {
  file: string;
  name: string;
}

interface Icon {
  media: IconMedia;
}

interface Item {
  icon?: Icon;
  name: string;
  reference?: {
    link?: string;
    openInNewWindow?: string;
  };
}

interface FooterInfoProps {
  items: Item[];
}

const FooterInfo: React.FC<FooterInfoProps> = ({ items }) => {
  if (!items) return null;

  return (
    <div className={styles.footerInfo}>
      <div className={styles.footerInfoWrap}>
        {items.map((item, index) => {
          return (
            <div key={index} className={styles.footerInfoItem}>
              {item.icon?.media?.file && (
                <svg>
                  <image xlinkHref={item.icon.media.file} href={item.icon.media.file} />
                </svg>
              )}
              {item.reference?.link ? (
                <Link
                  className={styles.footerInfoTitle}
                  dataButtonType="nodeLink"
                  link={item.reference.link}
                  ariaLabel={item.name}
                  target={item?.reference?.openInNewWindow ? '_blank' : '_self'}
                >
                  <span>{item.name}</span>
                </Link>
              ) : (
                <div className={styles.footerInfoTitle}>{item.name}</div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default FooterInfo;
